import m from "../../es2015/lang/pt_BR";
window.am4lang_pt_BR = m;


//////////////////
// WEBPACK FOOTER
// ./lang/pt_BR.js
// module id = null
// module chunks = 